import { memo, useMemo } from 'react';
import { NodeProps, NodeToolbar, useStore, NodeResizer, Handle, Position } from 'reactflow';

import { getRelativeNodesBounds } from './utils';
import PlutoDialogTitle from '../PlutoDialogTitle';

const lineStyle = { borderColor: 'white' };

export const getGroupLabelHeight = (label: string) => (label.length < 28 ? 60 : 90);

function GroupNode({ id, data = {}, selected }: NodeProps) {
    const bounds = useStore(
        useMemo(
            () => (store) => {
                const childNodes = Array.from(store.nodeInternals.values()).filter((n) => n.parentNode === id);
                const rect = getRelativeNodesBounds(childNodes);

                return {
                    minWidth: rect.x + rect.width,
                    minHeight: rect.y + rect.height,
                    hasChildNodes: childNodes.length > 0,
                };
            },
            [id],
        ),
        isEqual,
    );

    const handleStyle = useMemo(() => ({ opacity: selected ? 1 : 0, zIndex: 10 }), [selected]);

    return (
        <div>
            <PlutoDialogTitle title={data.label} className="pl-[18px] pr-[18px] pt-[16px] pb-[16px]" />
            <Handle type="source" id={Position.Top} position={Position.Top} style={handleStyle} />
            <Handle type="source" id={Position.Left} position={Position.Left} style={handleStyle} />
            <NodeResizer
                lineStyle={lineStyle}
                minHeight={bounds.minHeight}
                minWidth={bounds.minWidth}
                isVisible={selected}
            />
            <NodeToolbar className="nodrag" />
            <Handle type="source" id={Position.Bottom} position={Position.Bottom} style={handleStyle} />
            <Handle type="source" id={Position.Right} position={Position.Right} style={handleStyle} />
        </div>
    );
}

type IsEqualCompareObj = {
    minWidth: number;
    minHeight: number;
    hasChildNodes: boolean;
};

function isEqual(prev: IsEqualCompareObj, next: IsEqualCompareObj): boolean {
    return (
        prev.minWidth === next.minWidth &&
        prev.minHeight === next.minHeight &&
        prev.hasChildNodes === next.hasChildNodes
    );
}

export default memo(GroupNode);
